import type { $Fetch } from "ofetch";

/**

 * Nome do Controller da API

 */

const controller = "/relatorio";

/**

 * Classe de gerenciamento de chamadas da API de relatórios

 *

 * @class

 */

export default class ReportApi {
  /**

   * Instância da dependência da API (ofetch)

   */

  private api; /**

   * Cria uma nova instância da classe ReportApi.

   * @constructor

   * @param api - Instância da dependência da API (ofetch).

   */

  constructor(api: $Fetch) {
    this.api = api;
  } /**

   * Retorna uma lista de relatórios com base no código do módulo aplicação

   * @param codAplicacao - Código do módulo aplicação

   * @returns lista de relatórios

   */

  list(codAplicacao: number) {
    return this.api<ReportListItem[]>(`${controller}/GetCarregarRelatorio`, {
      method: "GET",
      params: {
        codAplicacao,
      },
    });
  }

  listAllTabela() {
    return this.api<ReportListItem[]>(`${controller}/GetListaTabelas`, {
      method: "GET",
    });
  }

  listarTabelasEColunas() {
    return this.api<string>(`${controller}/GetListarTabelasEColunas`, {
      method: "GET",
    });
  }
  /**

   * Retorna uma relatório a partir do código do relatório

   * @param codRelatorio - Código do relatório

   * @returns relatório detalhado

   */

  get(codRelatorio: number) {
    return this.api<DetailedReport>(
      `${controller}/GetPreencherCombosRelatorio`,
      {
        method: "GET",
        params: { codRelatorio },
      },
    );
  } /**

  /**
   * Realiza o cadastro de um relatório xml/json
   * @param xml - relatório em xml/json
   * @param codAplicacao - Código do módulo aplicação
   * @returns booleano
   */
  post(
    xml: string,
    estruturaDashboard: string,
    codAplicacao: number,
    codRelatorio?: number,
  ) {
    if (!codRelatorio) {
      codRelatorio = 0;
    }
    return this.api<boolean>(`${controller}/PostCadastroRelatorio`, {
      method: "POST",
      body: [
        {
          codRelatorio: codRelatorio,
          codAplicacao: codAplicacao,
          estruturaDashboard: estruturaDashboard,
          xml: xml,
        },
      ],
    });
  }

  /**
   * Realiza a conversão de um relatório xml para json no backend

   * @param xml - relatório em xml

   * @returns relatório em json

   */

  postConvertXmlToJson(xml: string) {
    return this.api<DetailedReport>(`${controller}/ConvertXmlToJson`, {
      method: "POST",
      body: { query: xml },
    });
  } /**

   * Realiza a remoção de um relatório do banco

   * @param codRelatorio - Código do relatório

   * @returns boolean

   */

  delete(codRelatorio: number) {
    return this.api(`${controller}/RemoverRelatorio`, {
      method: "POST",
      params: {
        codRelatorio,
      },
    });
  } /**

   * Realiza a remoção de um relatório do banco

   * @param codRelatorio - Código do relatório

   * @returns boolean

   */

  getData(
    codRelatorio: number,
    parametrosObject: ReportParams,
    gerarSQL: boolean,
  ) {
    const defaultSQL = false;
    if (gerarSQL === undefined) {
      gerarSQL = defaultSQL;
    }
    return this.api<any[]>(`${controller}/GetPesquisarAllPages`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      timeout: 600000, // 10 minutos
      body: JSON.stringify({
        codRelatorio,
        parametros: JSON.stringify(parametrosObject),
        gerarSQL: gerarSQL,
      }),
    });
  } /**

   * Realiza a pesquisa das opções do filtro que possuem registros no período selecionado

   * @param codRelatorio - Código do relatório

   * @param idFiltro - Código do filtro

   * @param parametrosObject  - Parâmetro do período pesquisado

   * @returns lista com as opções de valores do filtro

   */

  getComboItensByTimePeriod(
    codRelatorio: number | number[],
    idFiltro: number | number[],
    parametrosObject: ReportParams,
  ) {
    return this.api<any[]>(`${controller}/GetItensPeriodo`, {
      method: "GET",

      params: {
        codRelatorio,

        idFiltro,

        parametros: JSON.stringify(parametrosObject),
      },
    });
  } /**

   * Realiza a busca do json do relatório desejado

   * @param codRelatorio - Código do relatório

   * @returns json do relatório

   */

  getReportJson(codRelatorio: number | number[]) {
    return this.api<string>(`${controller}/GetRetornaXmlRelatorio`, {
      method: "GET",
      params: {
        codRelatorio,
      },
    });
  }
  /**

   * Realiza a listagem das tabelas e colunas do relatório desejado

   * @param getListaTabelasColunas - Código do relatório

   * @returns (string) lista com todas as variaveis do relatório

   */

  listarTabelasColunas() {
    return this.api<string>(`${controller}/GetListaTabelasColunas`, {
      method: "GET",
    });
  }

  /**

   * Realiza a listagem das tabelas e colunas do relatório desejado

   * @param getListaTabelasColunasPorTabelas - Código do relatório

   * @returns (string) lista com todas as variaveis do relatório

   */

  listarTabelasColunasPorTabela(tabela: string) {
    return this.api<string>(`${controller}/GetListaTabelasColunasPorTabelas`, {
      params: {
        tabela,
      },
      method: "GET",
    });
  }
  /**

   * Realiza execução do SQL para construção da tabela do relatório desejado

   * @param ExecutarTesteRelatorio - query Relatorio

   * @returns (string) tabela com execução do SQL

   */

  executarTabelas(query: string) {
    const id = "";
    const result = new Object();
    const gerarSQL = false;
    return this.api(`${controller}/ExecutarTesteRelatorio`, {
      method: "POST",
      body: {
        id,
        query,
        result,
        gerarSQL,
      },
    });
  }
}
